
// Начальный лимит данных
const LIMIT = 2

// Url адрес для запроса данных
const URL = 'articles/streams/video/popular/month'
export default {
  name: 'PagesStreamVideo',
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      videos: [],
      videosCount: 0,
    }
  },
  async fetch() {
    if (this.stream) {
      const { videos, countAllPublishedVideos } = await this.$axios.$get(URL, {
        params: {
          streams: [this.stream.id],
          limit: LIMIT,
          offset: 0,
        },
      })

      this.videosCount = countAllPublishedVideos
      this.videos = videos
    }
  },
  methods: {
    updateVideo() {
      this.videos = []
      this.$fetch()
    },
  },
}
